import React from 'react';
import {useDarkMode} from "../../contexts/darkModeContext";

export function getBulkProducts(products) {
    return products.filter(product => String(product?.productCode || '').trim().toUpperCase().endsWith('BUL'));
}

export function bulkConfirmationKey(products) {
    return JSON.stringify(products.map(product => [product.productCode, product.name, product.quantity, product.selectedVolume]));
}

export default function BulkProductConfirmation({ products, confirmed, onChange }) {
    const { darkMode } = useDarkMode();
    
    if (!products.length) return null;
    return (
        <section className={`mt-2 ${darkMode ? 'bg-white/5' : 'bg-black/5'} rounded-xl  border-green-600 `}>
            <h4 className="px-3 pt-3 font-semibold">Confirm BUL products and quantities</h4>
            <p className={`px-3 pb-1.5 leading-none text-xs opacity-50 italic border-b border-opacity-50 ${darkMode ? 'border-neutral-700' : 'border-gray-300'}`}>Review every BUL product below before continuing. Close this popup to correct an item.</p>
            <ul className={`px-3 mb-3 py-3 max-h-40 border-b border-opacity-50 ${darkMode ? 'border-neutral-700' : 'border-gray-300'} overflow-y-scroll scrollbar-hide space-y-2 text-sm`}>
                {products.map((product, index) => (
                    <li key={index} className={`relative overflow-hidden rounded-lg ${darkMode ? 'bg-white/5' : 'bg-black/5'} p-2`}>
                        <div className="font-semibold">{product.name} ({product.productCode})</div>
                        <div className={`opacity-50 leading-none mt-0.5 italic`}>Quantity: <strong>{product.quantity}</strong>{product.selectedVolume ? ` · Unit/size: ${product.selectedVolume}` : ''}</div>
                        
                        <div className={`text-white absolute flex items-center gap-1 justify-center top-0 right-0 bg-green-600 rounded-bl-lg px-2 py-1`}>
                            <span className={`leading-none font-extrabold`}>{product.quantity}</span>
                            <span className={`leading-none lowercase text-xs font-bold`}>{product.selectedVolume}</span>
                        </div>
                    
                    </li>
                ))}
            </ul>
            <label className="px-3 pb-3 flex cursor-pointer items-center gap-2 text-sm">
                <input type="checkbox" className="h-4 w-4 accent-green-600" checked={confirmed} onChange={event => onChange(event.target.checked)} />
                <span className={`leading-none opacity-70 italic`}>I confirm that all BUL products and quantities listed above are correct.</span>
            </label>
        </section>
    );
}
